export default __webpack_public_path__ + "assets/logo_della8_light-506563e8.svg";